import View from "../account/views/CancelArticleView";
import components from "./components.js";
components.define("js-ArticleCancelable", View);